/**
 * API «строк для продажи» собственной номенклатуры: настройки продажи ресурса и цена с ставкой НДС по выбранным карточкам.
 * Только чтение; данные кэшируются по ресурсу.
 */
import { baseApi, resourceScopeTag } from '@krp/client-runtime'

import { decodeOwnSaleLines, decodeOwnSaleSettings, type OwnSaleLines, type OwnSaleSettings } from './linesContracts'
import { OWN_SALE_URLS } from './urls'

export interface OwnSaleSettingsArgs {
  resourceId: string
}

export interface OwnSaleLinesArgs {
  resourceId: string
  /** Ключи карточек из поиска для продажи, 1…200; порядок — как в выдаче. */
  cardKeys: readonly string[]
  /** Вид цены кассира; нет — вид по умолчанию из настроек продажи. */
  priceTypeKey?: string
}

export const ownLinesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    ownSaleSettings: build.query<OwnSaleSettings, OwnSaleSettingsArgs>({
      query: ({ resourceId }) => ({ url: OWN_SALE_URLS.saleSettings(resourceId), decode: decodeOwnSaleSettings }),
      providesTags: (_result, _error, { resourceId }) => [resourceScopeTag(resourceId)],
    }),
    /** POST, но чтение: цена и ставка НДС строк, эффекта нет. */
    ownSaleLines: build.query<OwnSaleLines, OwnSaleLinesArgs>({
      query: ({ resourceId, cardKeys, priceTypeKey }) => ({
        url: OWN_SALE_URLS.saleLines(resourceId),
        method: 'POST',
        body: { cardKeys, ...(priceTypeKey === undefined ? {} : { priceTypeKey }) },
        decode: decodeOwnSaleLines,
      }),
      providesTags: (_result, _error, { resourceId }) => [resourceScopeTag(resourceId)],
    }),
  }),
})

export const { ownSaleSettings, ownSaleLines } = ownLinesApi.endpoints
